import { createReducer, on } from '@ngrx/store';
import * as AgentListActions from './Agentlist.action';

export interface AgentListState {
  agents: any[];
  loading: boolean;
  error: any;
}

export const initialAgentListState: AgentListState = {
  agents: [],
  loading: false,
  error: null
};

export const agentListReducer = createReducer(
  initialAgentListState,
  on(AgentListActions.loadAgentList, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(AgentListActions.loadAgentListSuccess, (state, { agents }) => ({
    ...state,
    agents,
    loading: false,
    error: null
  })),
  on(AgentListActions.loadAgentListFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
);
